export default __webpack_public_path__ + "static/media/nodejs.97feae6f.svg";